 <div style="padding:10%;">
    <div></div>
    <div style="text-align: center; margin:auto">

      <h3>One moment please...</h3>

      <img src="/assets/img/spinner.gif">

    </div>
 </div>
 